<template>
    <suchfeld-info v-if="currentSuchfeldId>0" :litId="currentSuchfeldId">

    </suchfeld-info>
    <div class="home" v-if="currentSuchfeldId==null" id="cisRsi">
        <div class="tsKampagnenBox">
            <div v-for="data in openRoundList" :key="data.RouId" class="tsFor">
                <div class="tsKampagneWlcHeader">
                    {{tx.HeaderTitle}}
                    <br />
                    {{tx.HeaderWelcome}}
                </div>


                <div class="tsKampagneWlc">
                    {{tx.HeaderCaption}}
                    <br />
                </div>
                <br />
                <br />
                <div class="trBox">


                    <div class="tsHeader">
                        <h2 class="tsKampagneTitle">
                            {{tx.SubHeadHorizon}}
                        </h2>
                        <div class="tsKampagneTxt">
                            {{tx.HorizonTextA}}

                            <br />
                            {{tx.HorizonTextB}}

                        </div>
                        <div>
                            <br />
                            <DxButton class="tsBtnDx" text="Zur Bewertung!" @click="openMyVoting()">
                                {{btn.toEvaluationBtn}}
                                <i class="far fa-flag-checkered"></i>
                            </DxButton>
                        </div>

                    </div>
                    <div calss="qualDiv">
                        <img class="qualPic" v-bind:src="pictureQualification" />
                    </div>

                    <div v-if="data.Suchfelder.length > 0" class="tsKampagne">

                        <div class="tsSuchfeldBox">
                            <div v-for="rec in data.Suchfelder" :key="rec.LitId" @click="openSuchfeldInfo(rec.LitId)" class="tsFor tsForIn">
                                <div class="tsSuchfeld">
                                    <div class="tsSuchfeldTitle">
                                        {{ rec.Title }}
                                    </div>
                                    <div class="tsSuchfeldImage">
                                        <img :src="rec.SufImageUri" />
                                    </div>
                                    <div class="tsSuchfeldDescription">
                                        <span v-html="rec.Description" />
                                    </div>
                                </div>
                                <!--<div class="tsButton">
                                    <DxButton class="tsBtnDx" text="Auswählen" @click="openRssBrowser(rec.LitId, data.RouId)" />
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="tsHeader">
                        <div class="tsKampagneTitle">
                            {{tx.SubHeadProzess}}
                        </div>


                    </div>
                    <img class="qualPic" v-bind:src="pictureWorkflow" />
                    <div class="tsKampagneTxtWorkflow">
                        {{tx.ProzessText}}
                    </div>
                    <div>

                        <DxButton class="tsBtnDx" text="Zur Bewertung!" @click="openMyVoting()">
                            {{btn.toEvaluationBtn}}
                            <i class="far fa-flag-checkered"></i>
                        </DxButton>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DxButton } from 'devextreme-vue/button'
    import suchfeldInfo from '../views/SuchfeldInfo.vue'
    export default {
        name: 'DashboardExpert',
        components: {
            DxButton,
            suchfeldInfo
        },
        data() {
            return {
                pictureWorkflow: "~/Images/workflow.png",
                pictureQualification: "~/Images/Qualifications.png",
                currentSuchfeldId: null,
                tx: {
                    HeaderTitle: this.$LanguageProvider.GetResource("HeaderTitle", "Header", "Liebe Expert:innen,"),
                    HeaderWelcome: this.$LanguageProvider.GetResource("HeaderWelcome", "Header", "Herzlich Willkommen bei der Denkfabrik.AI!"),
                    SubHeadHorizon: this.$LanguageProvider.GetResource("SubHeadHorizon", "Header", "Kampagne: BMAS Horizon Scanning"),
                    SubHeadProzess: this.$LanguageProvider.GetResource("SubHeadProzess", "Header", "Unser Arbeitsprozess: Der Foresight und Ideation Funnel"),
                    ProzessText: this.$LanguageProvider.GetResource("ProzessText", "Caption", "Wir sammeln und bündeln Themen, clustern und bewerten diese und ermöglichen dann dem BMAS mögliche Potentiale und Maßnahmen zu ergründen um wünschenswerte Zukünfte auf dem Arbeitsmarkt zu ermöglichen."),
                    HorizonTextA: this.$LanguageProvider.GetResource("HorizonTextA", "Caption", "Sie sind eingeladen die Potentiale der Kampagne: BMAS Horizon Scanning zu bewerten. Dafür haben unsere Redakteur: innen die folgenden 6 Suchfelder definiert."),
                    HorizonTextB: this.$LanguageProvider.GetResource("HorizonTextB", "Caption", "Ihre Bewertungen und Einschätzungen helfen uns dabei, relevante Themen zu selektieren und zu systematisieren.Bitte bewerten und kommentieren Sie detailliert, damit wir Ihre Ergebnisse für den BMAS Horizon Scanning Report 2022 nutzen können."),
                    HeaderCaption: this.$LanguageProvider.GetResource("HeaderCaption", "Caption", "Hier ist der Ort, um gemeinsam in Zukünften zu denken. Hier arbeiten Scouts, Künstliche Agenten und Redakteur:innen Hand in Hand um Wissen zu extrahieren und spannende Themen zu identifizieren, zu denen Sie sich positionieren."),
                },
                btn: {
                    toEvaluationBtn: this.$LanguageProvider.GetResource("toEvaluationBtn", "Caption", "zur Bewertung"),
                }
            }
        },
        computed: {

            openRoundList() {

                return this.$store.state.roundStore.openRoundList
            },
        },
        mounted() {

            this.$store.dispatch("getOpenRoundListWithSuchfelder")

        },
        watch: {
        },
        methods: {
            openMyVoting() {
                window.LoadPanel.Show()
                window.location = "MyIdeaEvaluationOverviewDx.aspx"
            },
            openSuchfeldInfo(recLitId) {
                this.currentSuchfeldId = recLitId;
            }
        }

    }

</script>

<style scoped>
    .bcBreadCrumb {
        display: none;
    }

    .tsForIn {
        border: solid 1px #ebebeb;
        margin: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }


    .tsSuchfeldDescription {
        padding-top: 10px;
        font-size: var(--grid-suchfeld-description-size);
        color: var(--grid-suchfeld-description-color);
    }


    .tsSuchfeldTitle {
        min-height: 35px;
        /*  padding: 6px 6px 0 15px;*/
        font-size: var(--grid-suchfeld-title-size);
        color: var(--grid-suchfeld-title-color);
        font-weight: bold;
    }

    .tsKampagne {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .tsKampagneTitle {
        font-size: 20px;
        font-weight: bold;
        padding-left: 0px;
        color: #717c86;
        text-transform: uppercase;
        padding-top: 10px;
    }

    .tsSuchfeldImage {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3%;
        padding: 0
    }



    .tsKampagneWlc {
        color: white;
        padding-left: 15px;
        max-width: 700px;
        font-size: 15px;
        padding-top: 10px;
    }

    .tsKampagneTxt {
        color: white;
        padding-left: -15px;
        padding-top: 10px;
        max-width: 700px;
        font-size: 15px;
        min-height: 120px;
    }

    .tsKampagneTxtWorkflow {
        color: white;
        padding-left: -15px;
        padding-top: 10px;
        max-width: 700px;
        font-size: 15px;
        min-height: 80px;
    }

    .tsKampagneWlcHeader {
        color: #f4c543;
        padding-left: 15px;
        padding-top: 10px;
        font-size: 35px;
        font-weight: bold;
    }

    .tsHeader {
        display: flex;
        flex-direction: column;
        /*justify-content: space-between;*/
        padding-left: 15px;
        /*   align-items: self-end;*/
    }

    .trBox {
        display: grid;
    }

    .tsWorkflow {
        color: white;
        max-width: 1200px;
    }

    .tsHeader img {
        max-width: 100%;
        padding: 10px;
    }

    .tsSuchfeldImage img {
        width: 100%;
        object-fit: cover;
        height: 225px;
    }

    .tsSuchfeld {
        padding: 15px;
        align-content: center;
    }


    .tsSuchfeldBox {
        display: grid;
        grid-row-gap: 30px;
        grid-column-gap: 30px;
        grid-template-columns: repeat(auto-fit, 400px);
        padding: 10px;
        max-width: 90%;
    }

    .tsFor.tsForIn {
        cursor: pointer;
        background-color: white
    }

        .tsFor.tsForIn:hover {
            background-color: whitesmoke;
        }

    .tsButton {
        margin-top: 15px;
        display: flex;
        justify-content: center;
        padding-bottom: 14px;
    }

    .tsForIn:hover {
        box-shadow: 0px 0px 5px 0px rgb(255 255 255 / 50%);
    }

    .tsBtnDx {
        width: auto;
        background-color: var(--m02-color-1);
        margin-bottom: 30px;
        padding: 7px;
    }

        .tsBtnDx:hover {
            background-color: var(--danger-hover-color);
            box-shadow: 0px 0px 5px 0px rgb(255 255 255 / 50%);
        }

    .tsFor {
    }


    .tsKampagneImage {
        width: 100px;
    }

    .workflowPic {
        max-width: 68%;
        padding: 10px;
    }

    .qualPic {
        padding-left: 15px;
        max-width: 700px;
        padding-top: 20px;
    }
     
</style>
